module.exports = __webpack_public_path__ + "img/upstox logo.db77a01f.svg";